import React from 'react';

import {gaasCountries} from '../../../../../../../util/uiconstants';

export const prop = 'pGaas';

export const config = (labels) => ({
	id: 'standardsColumn',
	label: labels.standars,
	propName: prop,
	width: 'minmax(var(--px-130), 1fr)',
	sortBy: prop,
	customCell: (item) => {
		return gaasCountries.find((x) => x.profileAnswerOptionId === item.pGaas)?.profileAnswerOptionValue;
	}
});
